import PropTypes from 'prop-types';

import React from 'react';
import { connect } from 'react-redux';

import { spellCheck } from '../SpellCheck/actions';

import EditorHeader from '../../components/EditorHeader';

export class EditorHeaderContainer extends React.PureComponent {
  handleClickSpellcheck = () => !this.props.readOnly && this.props.spellCheck();

  render() {
    return (
      <EditorHeader
        onClickSpellcheck={this.handleClickSpellcheck}
      />
    );
  }
}

EditorHeaderContainer.propTypes = {
  readOnly: PropTypes.bool,
  spellCheck: PropTypes.func,
};

function mapDispatchToProps(dispatch) {
  return {
    spellCheck: () => {
      dispatch(spellCheck());
    },
  };
}

export default connect(null, mapDispatchToProps)(EditorHeaderContainer);
